import { v4 as uuidv4 } from 'uuid';
import moment from 'moment/moment';
import { Crisp } from 'crisp-sdk-web';
import startCase from 'lodash/startCase';
import { isUUIDExpired } from '@mgm/common/lib';

type TCrispSessionData = {
  email: string
  name: string
};

export function useCrisp() {
  const setCrispSession = (crispData: TCrispSessionData) => {
    const userUUIDData = sessionStorage.getItem('userUUIDData');
    let uuidData;
    let isNewUUID = false;

    try {
      if (typeof userUUIDData === 'string') {
        uuidData = JSON.parse(userUUIDData);
      }
    } catch (error) {
      uuidData = null;
    }

    if (!uuidData || isUUIDExpired(uuidData?.timestamp)) {
      uuidData = {
        uuid: uuidv4(),
        timestamp: moment().toISOString(),
      };
      sessionStorage.setItem('userUUIDData', JSON.stringify(uuidData));
      isNewUUID = true;
    }

    Crisp.setTokenId(uuidData.uuid);

    Crisp.user.setEmail(crispData.email);
    Crisp.user.setNickname(crispData.name);

    Crisp.session.pushEvent('signin');

    // Display welcome message only if the UUID is new
    if (isNewUUID) {
      window.$crisp.push(['do', 'message:show', ['text', `Welcome to ManageMate, ${startCase(crispData.name)}!`
      + '\n'
      + 'Thanks for logging in. We\'re here to help if you need anything.']]);
    }
  };

  return {
    setCrispSession,
  };
}
